import React, { useState, useEffect } from "react";
import BreadCrumbBanner from "../../component/BreadCrumbBanner";
import facilitiesAPI from "../../api/facilitiesApi";
import { motion, AnimatePresence } from "framer-motion";

const PhysicalEducation = () => {
  const [activeSport, setActiveSport] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [physicalData, setPhysicalData] = useState([]);
  const [athleticData, setAthleticData] = useState([]);

  useEffect(() => {
    fetchSports();
  }, []);

  const fetchSports = async () => {
    const res = await facilitiesAPI.physical_education();

    if (res.code === 200) {
      const result = res.data;

      setPhysicalData(result["physical-education"] || []);
      setAthleticData(result["athletic-excellence"] || []);
    }
  };

  const openModal = (sport) => {
    setActiveSport(sport);
    setCurrentSlide(0);
    document.body.style.overflow = "hidden";
  };

  const closeModal = () => {
    setActiveSport(null);
    document.body.style.overflow = "auto";
  };

  useEffect(() => {
    if (activeSport) {
      setCurrentSlide(0);
    }
  }, [activeSport]);

  // Auto-slide logic
  useEffect(() => {
    if (activeSport) {
      const timer = setInterval(() => {
        setCurrentSlide(
          (prev) => (prev + 1) % (activeSport.image?.length || 1),
        );
      }, 3000);
      return () => clearInterval(timer);
    }
  }, [activeSport]);

  const physInfo = physicalData?.[0];
  const atheleteInfo = athleticData?.[0];
  return (
    <>
      <BreadCrumbBanner
        title="Sports & Physical Education"
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      {/* sports section */}
      {physicalData.length > 0 && (
        <section className="sports-modern-section bg-light  py-5">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-6 animate__animated animate__fadeInRight order-md-1 order-2">
                <span className="mrv-subtitle">{physInfo?.subtitle}</span>
                <h2 className="mrv-title">{physInfo?.title}</h2>
                <p className="sports-desc">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: physInfo?.description || "",
                    }}
                  />
                </p>
                <div className="sports-content-grid">
                  {physInfo?.listings?.map((item, index) => (
                    <div className="sports-point">
                      <img className="library-icon" src={item.icon} loading="lazy" />
                      <div>
                        <h6>{item.listingtitle}</h6>
                        <p>{item.listingdescription}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {/* RIGHT : image */}
              <div className="col-lg-6 animate__animated animate__fadeInLeft order-md-2 order-1">
                <div className="sports-image-box">
                  <img
                    src={physInfo?.image}
                    alt="School Sports"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      {athleticData.length > 0 && (
        <section className="mrv-sports-section">
          <div className="container">
            <div className="text-center mb-5">
              <span
                className="mrv-subtitle"
                style={{ color: "var(--secondary-color)", fontWeight: "bold" }}
              >
                Athletic Excellence
              </span>
              <h2 className="mrv-title" style={{ fontSize: "3rem" }}>
                Explore Our Games
              </h2>
            </div>

            <div className="mrv-sports-grid">
              {athleticData.map((sport) => (
                <div
                  key={sport.id}
                  className="mrv-sports-card"
                  onClick={() => openModal(sport)}
                >
                  <img
                    className="library-icon mb-2"
                    src={sport.icon}
                    alt={sport.subtitle}
                    loading="lazy"
                  />
                  <h3>{sport.subtitle}</h3>
                  <p>{sport.title}</p>

                  <div>
                    <span
                      style={{
                        color: "var(--secondary-color)",
                        fontWeight: "bold",
                      }}
                    >
                      View Details →
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Sport Modal */}
      {activeSport && (
        <div className="mrv-sports-modal-overlay" onClick={closeModal}>
          <div
            className="mrv-sports-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="mrv-sports-close" onClick={closeModal}>
              &times;
            </button>

            {/* Image Slider */}
            <div className="mrv-sports-slider-box">
              {activeSport?.image?.length > 0 && (
                <AnimatePresence mode="wait">
                  <motion.img
                    key={currentSlide}
                    src={activeSport.image[currentSlide]}
                    alt={activeSport.subtitle}
                    className="mrv-sports-slide-img"
                    loading="lazy"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{
                      duration: 0.9,
                      ease: "easeInOut",
                    }}
                  />
                </AnimatePresence>
              )}

              <div
                style={{
                  position: "absolute",
                  bottom: "20px",
                  left: "20px",
                  color: "#fff",
                  background: "rgba(0,0,0,0.5)",
                  padding: "5px 15px",
                  borderRadius: "20px",
                }}
              >
                {currentSlide + 1} / {activeSport.image?.length}
              </div>
            </div>

            {/* Content Box */}
            <div className="mrv-sports-info-box">
              <span className="mrv-sports-modal-accent">
                {activeSport.title}
              </span>
              <h2 className="mrv-sports-modal-title">
                {" "}
                {activeSport.subtitle}
              </h2>
              <div
                className="sports-desc"
                dangerouslySetInnerHTML={{
                  __html: activeSport.description || "",
                }}
              />

              <h5
                className="mt-1"
                style={{ color: "var(--primary-color)", fontWeight: "800" }}
              >
                Major Tournaments
              </h5>
              <ul className="mrv-sports-modal-list">
                {activeSport.listingpoint?.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PhysicalEducation;
